<div *ngFor="let validator of validators" role="alert" class="ant-form-item-explain-error">
    {{ getErrorKey(validator) }}
</div>